<script>
export default {
  props: {
    module: Object,
  },
};
</script>
<template>
  <CardBody :html="module.html" />
</template>
